<template>
  <div class="col-6 col-sm-3">
    <span class="pb-1 font-size-xs mb-1"> {{ label }} </span>
    <vue-slider
      v-model="appliedFilters"
      v-bind:min="min"
      v-bind:max="max"
      v-bind:interval="interval || 1"
    ></vue-slider>
  </div>
</template>

<script>
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';
import store from '../store';
import { isEntityVisible } from '../filter.function';

export default {
  name: 'SlideFilter',
  props: ['options', 'label', 'name', 'min', 'max', 'interval'],
  store,
  components: { VueSlider },
  data: function() {
    return {
      appliedFilters: store.getters.filters.casino && store.getters.filters.casino.find(e => e.type === this.name) ?  store.getters.filters.casino.find(e => e.type === this.name).value : undefined ,
    };
  },
  watch: {
    appliedFilters: function(val) {
      console.log(val);
      this.filterResults(val);
    },
  },
  methods: {
    filterResults(appliedFilters) {
      if (appliedFilters !== 0) {
        if (store.getters.filters.casino.find((e) => e.type == this.name)) {
          store.getters.filters.casino.find(
            (e) => e.type == this.name
          ).value = appliedFilters;
          store.commit('setFilters', store.getters.filters);

        } else {
          store.getters.filters.casino.push({
            type: this.name,
            value: appliedFilters,
          });
          store.commit('setFilters', store.getters.filters);

        }
      } else {
        store.commit('setFilters', {
          ...store.getters.filters,
          casino: store.getters.filters.casino.filter(
            (e) => e.type !== this.name
          ),
        });
      }

      const finalResults = [];
      for (let result of store.getters.results) {
        result.visible = isEntityVisible(store.getters.filters.casino, result);
        finalResults.push(result)
      }
      store.commit('setResults', finalResults);
    },
  },
};
</script>
